import React from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import AmbuNetLogo from '../assets/images/ambunetLogo.png'
import loaderGif from '../assets/images/loader.gif'

const NotFound = ({ returnUrl }) => {
  const navigate = useNavigate()

  return (
    <Box
      // minHeight="100vh"
      // height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={3}
      my={-1}
      mx={-2}
      sx={{
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 600,
          borderRadius: 4,
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.18)',
          boxShadow: '0 2px 4px rgba(0,0,0,0.35)',
          background: 'rgba(255,255,255,0.96)',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            p: 3,
            background:
              'linear-gradient(135deg, #242F40 0%, #2c3e50 65%, #239AA4 150%)',
            color: 'white',
            textAlign: 'center',
          }}
        >
          <Box component="img" alt="Logo" src={loaderGif} width="120px" />

          <Typography variant="h5" fontWeight={900} color="white" mt={1}>
            Page not found
          </Typography>

          <Typography
            variant="body2"
            sx={{ opacity: 0.75, mt: 1, color: 'white' }}
          >
            The page you are looking for does not exist or may have been moved.
          </Typography>
        </Box>

        <Box p={3}>
          <Stack spacing={2}>
            <Alert severity="warning" icon={<SearchOffRoundedIcon />}>
              Please check the address, or return to AmbuNet and try again.
            </Alert>

            <Button
              fullWidth
              startIcon={<HomeRoundedIcon />}
              onClick={() => navigate(returnUrl ?? '/')}
              variant="contained"
              sx={{
                borderRadius: 999,
                py: 1.2,
                textTransform: 'none',
                fontWeight: 800,
              }}
            >
              Return home
            </Button>

            <Button
              fullWidth
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => navigate(-1)}
              variant="outlined"
              sx={{
                borderRadius: 999,
                py: 1.2,
                textTransform: 'none',
                fontWeight: 800,
              }}
            >
              Go back
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Box>
  )
}

export default NotFound
